import React from 'react'
import { useParams, useLocation } from 'react-router-dom'
import { useTranslation } from '@zauberware/react-i18n/web'
import { Breadcrumb as AntBreadcrumb } from 'antd'
import { FilterPortal } from '../../atoms'
import useBreadcrumbQueries from './useBreadcrumbQueries'
import './Breadcrumbs.scss'

// Turn a route slug like "customers-allocation" into a readable label
// ("Customers Allocation") as a fallback when no translation key exists.
const humanizeSlug = slug =>
  String(slug)
    .replace(/[-_]+/g, ' ')
    .replace(/\b\w/g, c => c.toUpperCase())

const Breadcrumbs = () => {
  const { t } = useTranslation('common')
  const params = useParams()
  const location = useLocation()
  const path = location.pathname

  const crumbs = useBreadcrumbQueries(path, params)

  const populateBreadcrumbs = () => {
    const sections = path.split('/').slice(2)
    const subPaths = path.split('/')
    return sections.map((section, index) => {
      let name = section
      let clickable = index === 0
      // Resolved dynamic names (asset titles, customer names, …) are real labels
      // and must be rendered verbatim – not translated or humanized.
      let isDynamic = false

      // Check if this section matches a route param (is a dynamic ID)
      if (section === params?.id && crumbs.id) {
        name = crumbs.id
        clickable = true
        isDynamic = true
      } else if (section === params?.inquiryId && crumbs.inquiryId) {
        name = crumbs.inquiryId
        clickable = true
        isDynamic = true
      } else if (section === params?.customerId && crumbs.customerId) {
        name = crumbs.customerId
        clickable = true
        isDynamic = true
      }

      const href = subPaths.slice(0, index + 3).join('/')
      return { name, href, clickable, isDynamic }
    })
  }

  const renderElement = (item, index) => (
    <AntBreadcrumb.Item
      key={index}
      style={!item.clickable ? { cursor: 'default', color: '#000' } : { color: '#000' }}
      href={item.clickable ? item.href : undefined}
    >
      {item.isDynamic ? item.name : t(item.name, { defaultValue: humanizeSlug(item.name) })}
    </AntBreadcrumb.Item>
  )

  return (
    <FilterPortal>
      <AntBreadcrumb
        className="breadcrumb-nav"
        separator=">"
        style={{
          fontSize: '1.05rem',
          fontWeight: 400
        }}
      >
        {populateBreadcrumbs()?.map(renderElement)}
      </AntBreadcrumb>
    </FilterPortal>
  )
}

export default Breadcrumbs
